(function () {
	'use strict';

	const THRESHOLD = 0.25;

	function init() {
		const containers = document.querySelectorAll('.ee-timeline-v2');

		if (!containers.length) {
			return;
		}

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target.classList.add('in-view');
					observer.unobserve(entry.target);
				}
			});
		}, { threshold: THRESHOLD });

		containers.forEach((container) => {
			container.classList.add('has-animation');
			container.querySelectorAll('.timeline-row').forEach((row) => {
				observer.observe(row);
			});
		});

		initLightboxScrollLock();
	};

	const initLightboxScrollLock = () => {
		const observer = new MutationObserver(() => {
			const lightbox = document.querySelector('.elementor-lightbox');
			const isOpen = lightbox && lightbox.style.display !== 'none' && window.getComputedStyle(lightbox).display !== 'none';

			if (isOpen) {
				document.body.style.overflow = 'hidden';
			} else {
				document.body.style.removeProperty('overflow');
			}
		});

		observer.observe(document.body, {
			childList: true,
			subtree: true,
			attributes: true,
			attributeFilter: ['style', 'class'],
		});
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();